/**
 *     ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const L7RealServersEnum = {
    GET_LAYER_7_RIP: (id: string): string => {
        return '/haproxy/rips/' + id;
    },
    GET_LAYER_7_RIPS: '/haproxy/rips',
    GET_LAYER_7_RIPS_BY_BACKEND_ID: (id: string): string => {
        return `/haproxy/backends/${id}/rips`;
    },
    POST_LAYER_7_RIPS: '/haproxy/rips',
    PUT_LAYER_7_RIPS: (id: string): string => {
        return '/haproxy/rips/' + id;
    },
    DELETE_LAYER_7_RIPS: (id: string): string => {
        return '/haproxy/rips/' + id;
    },
    PUT_DRAIN_LAYER_7_RIP: (id: string): string => {
        return `/haproxy/rips/${id}/drain`;
    },
    PUT_ONLINE_LAYER_7_RIP: (id: string): string => {
        return `/haproxy/rips/${id}/online`;
    },
    PUT_HALT_LAYER_7_RIP: (id: string): string => {
        return `/haproxy/rips/${id}/halt`;
    },
    GET_HANGING_LAYER_7_RIPS: '/haproxy/rips/hanging',
};
